export const createSectionBuilder = data => {
  return {
    status: data?.status,
    message: data?.message,
    reference: data?.reference
  };
};
